import type React from 'react';

import { DesktopFilters } from './components/DesktopFilters';
import { MobileFilters } from './components/MobileFilters';
import { ResultsContent } from './components/ResultsContent';

export const SearchResult: React.FC = () => {
	return (
		<div data-qa="search-results-page-content">
			<MobileFilters />
			<div className="container mt-4 pb-20 md:mt-12">
				<div className="grid grid-cols-12 gap-4">
					<DesktopFilters />
					<div className="col-span-1 hidden md:flex" />
					<ResultsContent />
				</div>
			</div>
		</div>
	);
};
